import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ImagePickerComponent } from './image-picker/image-picker.component';
import { CheckImageModule } from '@shared/directives/check-image/check-image.module.module';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ImagePickerComponent],
  exports: [ImagePickerComponent],
  imports: [ CommonModule, CheckImageModule, MatIconModule, ReactiveFormsModule ],
})
export class ImagesModule {}
